import { render, staticRenderFns } from "./RoomsItem.vue?vue&type=template&id=9c66a9a8&scoped=true&"
import script from "./RoomsItem.vue?vue&type=script&lang=js&"
export * from "./RoomsItem.vue?vue&type=script&lang=js&"
import style0 from "./RoomsItem.vue?vue&type=style&index=0&id=9c66a9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c66a9a8",
  null
  
)

export default component.exports